// extracted by mini-css-extract-plugin
export default {"agencyReviewsTitle":"agencyReviewsTitle_G93oq","container":"container_cOlUq","title":"title_f9L2m","rating":"rating_BIH1I","totalRating":"totalRating_pxGcn"};